import React, { useEffect, useState, useRef } from "react";
import { getCategories } from "../services/categoryService";
import "../styles/Categories.css";
import { ChevronLeft, ChevronRight } from "lucide-react";
import { IMAGE_BASE_URL } from "../api/api";

function Categories() {
  const [categories, setCategories] = useState([]);
  const [loading, setLoading] = useState(true);
  const scrollRef = useRef(null);

  useEffect(() => {
    const fetchCategories = async () => {
      try {
        const data = await getCategories();
        setCategories(data);
      } catch (error) {
        console.error("Error loading categories:", error);
      } finally {
        setLoading(false);
      }
    };

    fetchCategories();
  }, []);

  const handleScroll = (direction) => {
    if (scrollRef.current) {
      const scrollAmount = direction === "left" ? -300 : 300;
      scrollRef.current.scrollBy({ left: scrollAmount, behavior: "smooth" });
    }
  };

  if (loading) return <p className="text-center my-5">📁 Loading categories...</p>;

  return (
    <div className="container my-5 position-relative">
      {/* Header */}
      <div className="d-flex justify-content-between align-items-center mb-4">
        <p className="mb-0 section-title">Explore Popular Categories</p>
        {/* <a
          href="#"
          className="text-decoration-none text-dark seeAll-text"
          style={{ cursor: "pointer" }}
        >
          See All
        </a> */}
      </div>

      {/* Scroll Buttons */}
      <button className="scroll-btn left" onClick={() => handleScroll("left")}>
        <ChevronLeft size={20} />
      </button>
      <button className="scroll-btn right" onClick={() => handleScroll("right")}>
        <ChevronRight size={20} />
      </button>

      {/* Scrollable Row */}
      <div
        ref={scrollRef}
        className="d-flex flex-nowrap overflow-auto gap-3 pb-2 scroll-container"
        style={{ scrollBehavior: "smooth" }}
      >
        {categories.map((cat) => {
          const imageUrl = cat.image
            ? `${IMAGE_BASE_URL}storage/${cat.image}` // ✅ use global image base URL
            : "https://media.istockphoto.com/id/1147544807/vector/thumbnail-image-vector-graphic.jpg?s=612x612&w=0&k=20&c=rnCKVbdxqkjlcs3xH87-9gocETqpspHFXu5dIGB4wuM=";

          return (
            <div
              key={cat.id}
              className="category-card text-white"
              style={{
                minWidth: "200px",
                maxWidth: "200px",
                flex: "0 0 auto",
                cursor: "pointer",
              }}
            >
              <img
                src={imageUrl}
                alt={cat.name}
                className="category-image"
                style={{
                  borderRadius: "10px",
                  height: "200px",
                  objectFit: "cover",
                  width: "100%",
                }}
              />
              <div className="overlay">
                <p className="category-title">{cat.name}</p>
              </div>
            </div>
          );
        })}
      </div>
    </div>
  );
}

export default Categories;
